import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as actions from '../redux/actions';
import * as tutorialActions from '../../tutorial/redux/actions';
import PageTab from './PageTab';
import EventTab from './EventTab';
import CollectionTab from './CollectionTab';
import SnippetTemplateTab from './SnippetTemplateTab';
import AssetTab from './AssetTab';
import { getBuilderURL } from '../../../common/utils/builder-url-util';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import { getCookie, isProjectReadOnly } from '../../../common/utils/api_utils';

export class SideBar extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };

  toggleSidebar = (event, name) => {
    const sideBarToVisible = document.getElementById(name);
    const alreadySelected = sideBarToVisible.classList.contains('selected');
    let i, tabcontent, tablinks;

    tabcontent = document.getElementsByClassName('sidebar');
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].classList.remove('selected');
    }

    tablinks = document.getElementsByClassName('gjs-tablinks');
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(' selected', '');
    }
    if (!alreadySelected) {
      sideBarToVisible.classList.add('selected');
      event.currentTarget.className += ' selected';
    }
  };

  openEditor = () => {
    const { projectId, version } = this.props;
    let token = getCookie('token');
    if (!token) {
      token = '';
    }
    const redirectUrl = getBuilderURL();
    window.location.href = `${redirectUrl}editor/${version}/v/${projectId}/loader?token=${token}`;
  };

  render() {
    const { projectId, actions, version } = this.props;
    let domainName = window.location.hostname;
    const developerApiDomain = domainName.split('.')[0];
    const isReadOnly = isProjectReadOnly(projectId);
    return (
      <Fragment>
        <div className="mini-sidebar">
          <ul>
            <li title="Components" onClick={this.openEditor} className="gjs-tablinks">
              <i className="wb webconnect-plus-square"></i>
            </li>
            <li
              title="Pages"
              onClick={(e) => this.toggleSidebar(e, 'PAGES')}
              className="gjs-tablinks"
            >
              <i className="wb webconnect-file-alt"></i>
            </li>

            <li
              title="Collections"
              onClick={(e) => this.toggleSidebar(e, 'COLLECTIONS')}
              className="gjs-tablinks"
            >
              <i className="wb webconnect-database"></i>
            </li>
            <li
              title="Snippets"
              onClick={(e) => this.toggleSidebar(e, 'TEMPLATES')}
              className="gjs-tablinks"
            >
              <i className="wb webconnect-bars"></i>
            </li>
            <li
              title="Events"
              onClick={(e) => this.toggleSidebar(e, 'EVENTS')}
              className="gjs-tablinks"
            >
              <i className="wb webconnect-diagram-3-fill"></i>
            </li>
            <li className="gjs-tablinks position-relative" title="Plugins">
              <Link to={`/plugin/${version}/v/${projectId}`} className="icon-link stretched-link">
                <i className="wb webconnect-tools"></i>
              </Link>
            </li>
            <li className="gjs-tablinks position-relative" title="External APIs">
              <Link
                to={`/externalapi/${version}/v/${projectId}`}
                className="icon-link stretched-link"
              >
                <i className="wb webconnect-rocket"></i>
              </Link>
            </li>
            <li title="Assets" onClick={this.openEditor} className="gjs-tablinks">
              <i className="wb webconnect-image_solid"></i>
            </li>
          </ul>
          <ul className="align-bottom" id="sidebar-submenu">
            <li className="gjs-tablinks" title="Project">
              <i className="wb webconnect-file-ppt-fill"></i>
              <ul>
                <li>
                  <a
                    href={`${process.env.REACT_APP_ORGANIZATION}dashboard`}
                    className="icon-link"
                    title="Project Dashboard"
                    target={'_blank'}
                  >
                    <i className="wb webconnect-grid-fill"></i> Dashboard
                  </a>
                </li>
                <li>
                  <a
                    href={`${process.env.REACT_APP_ORGANIZATION}${projectId}/project-detail`}
                    className="icon-link"
                    title="Project Settings"
                    target={'_blank'}
                  >
                    <i className="wb webconnect-gear"></i> Settings
                  </a>
                </li>
              </ul>
            </li>
            <li className="gjs-tablinks" title="Settings">
              <i className="wb webconnect-cogs"></i>
              <ul>
                <li>
                  <Link
                    to={`/app-setting/${version}/v/${projectId}/setting/app-config`}
                    className="icon-link"
                    title="App Setting"
                  >
                    <i className="wb webconnect-home"></i> App Setting
                  </Link>
                </li>
                <li>
                  <Link
                    to={{
                      pathname: `/app-setting/${version}/v/${projectId}/setting/custom-css`,
                    }}
                    className="icon-link"
                    title="Custom CSS"
                  >
                    <i className={`wb ${drapcodeIcon('customCSS')}`} /> Custom CSS
                  </Link>
                </li>
                <li>
                  <Link
                    to={{
                      pathname: `/app-setting/${version}/v/${projectId}/setting/custom-js`,
                    }}
                    className="icon-link"
                    title="Custom CSS"
                  >
                    <i className={`wb ${drapcodeIcon('customJS')}`} /> Custom JavaScript
                  </Link>
                </li>
                <li>
                  <Link
                    to={{
                      pathname: `/custom-component/${version}/v/${projectId}/customComponent`,
                    }}
                    className="icon-link"
                    title="Custom Component"
                  >
                    <i className={`wb ${drapcodeIcon('customComponent')}`} /> Custom Component
                  </Link>
                </li>
                <li>
                  <Link
                    to={{
                      pathname: `/app-setting/${version}/v/${projectId}/setting/pwa-config`,
                    }}
                    className="icon-link"
                    title="PWA Configuration"
                  >
                    <i className={`wb ${drapcodeIcon('pwa')}`} /> PWA Configuration
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/app-setting/${version}/v/${projectId}/setting/devKey`}
                    className="icon-link"
                    title="Developer API"
                  >
                    <i className={`wb ${drapcodeIcon('devKey')}`}></i> Developer API
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/app-setting/${version}/v/${projectId}/setting/encryption-section`}
                    className="icon-link"
                    title="Data Encryption"
                  >
                    <i className={`wb ${drapcodeIcon('encryption')}`}></i> Data Encryption
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/template/${version}/v/${projectId}/`}
                    className="icon-link"
                    title="Templates"
                  >
                    <i className="wb webconnect-file-alt"></i> Templates
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/data-connector/${version}/v/${projectId}`}
                    className="icon-link"
                    title="Data Source"
                  >
                    <i className="wb webconnect-hdd-stack-fill"></i> Data Source
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/externalapi/${version}/v/${projectId}`}
                    className="icon-link"
                    title="External APIs"
                  >
                    <i className="wb webconnect-rocket"></i> External APIs
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/app-setting/${version}/v/${projectId}/setting/localization-section`}
                    className="icon-link"
                    title="Localization"
                  >
                    <i className="wb webconnect-edit"></i> Localization
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/logger/${version}/v/${projectId}`}
                    className="icon-link"
                    title="System Logs"
                  >
                    <i className={`wb ${drapcodeIcon('logs')}`}></i> System Logs
                  </Link>
                </li>
                {/* <li>
                  <Link
                    to={`/app-setting/${version}/v/${projectId}/setting/version`}
                    className="icon-link"
                    title="Project Version"
                  >
                    <i className={`wb ${drapcodeIcon('version')}`}></i> Project Version
                  </Link>
                </li> */}
                <li>
                  <Link
                    to={`/schedule/${version}/v/${projectId}`}
                    className="icon-link"
                    title="Background Task"
                  >
                    <i className={`wb ${drapcodeIcon('alarm')}`}></i> Background Task
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/permission/${version}/v/${projectId}`}
                    className="icon-link"
                    title="Delete Permissions"
                  >
                    <i className={`wb ${drapcodeIcon('constants')}`}></i> Delete Permissions
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/deployment-setting/${version}/v/${projectId}/code-export`}
                    className="icon-link"
                    title="Code Export"
                  >
                    <i className={`wb ${drapcodeIcon('codeExport')}`}></i> Code Export
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/2.0/vibe-coding/${version}/v/${projectId}/chat`}
                    className="icon-link"
                    title="Vibe Coding"
                  >
                    <i className={`wb ${drapcodeIcon('vibeCoding')}`}></i> Vibe Coding
                  </Link>
                </li>
              </ul>
            </li>
            <li
              title="Tutorials"
              onClick={this.props.tutorialActions.toggleTutorialModal}
              className="gjs-tablinks"
            >
              <i className="wb webconnect-youtube"></i>
            </li>
            <li className="gjs-tablinks" title="Help/Tutorials">
              <i className="wb webconnect-info-circle"></i>
              <ul>
                <li>
                  <a
                    href="https://academy.drapcode.com/"
                    className="icon-link"
                    title="Product Manual"
                    target="_blank"
                  >
                    <i className="wb webconnect-file-alt"></i> Product Manual
                  </a>
                </li>
                <li>
                  <a
                    href={`https://${developerApiDomain}.drapcode.io/api/v1/docs`}
                    className="icon-link"
                    title="Developer API"
                    target="_blank"
                  >
                    <i className="wb webconnect-rocket"></i> Developer API
                  </a>
                </li>
                <li>
                  <a
                    href={`https://${developerApiDomain}.drapcode.io/api/v1/mcp/docs`}
                    className="icon-link"
                    title="Drapcode MCP"
                    target="_blank"
                  >
                    <i className="wb webconnect-tools"></i> Drapcode MCP
                  </a>
                </li>
                <li>
                  <a
                    href="https://drapcode.com/contact-us"
                    className="icon-link"
                    title="Need Help?"
                    target="_blank"
                  >
                    <i className="wb webconnect-envelope"></i> Need Help?
                  </a>
                </li>
                <li>
                  <a
                    href="https://join.slack.com/t/drapcode/shared_invite/zt-xvo04sdw-Whf_4z3KsWTu1wd8R_6rYQ"
                    className="icon-link"
                    title="Slack Community"
                    target="_blank"
                  >
                    <i className="wb webconnect-slack"></i> Slack Community
                  </a>
                </li>
                <li>
                  <a
                    href="https://discord.com/channels/844860999542898708/844861000510734358"
                    className="icon-link"
                    title="Discord Community"
                    target="_blank"
                  >
                    <i className="wb webconnect-discord"></i> Discord Community
                  </a>
                </li>
                <li>
                  <a
                    href="https://community.drapcode.com/"
                    className="icon-link"
                    title="Community"
                    target="_blank"
                  >
                    <i className="wb webconnect-address-card"></i> Community
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UCGQQj8iNARSHscemk9FY5uw"
                    className="icon-link"
                    title="Tutorials"
                    target="_blank"
                  >
                    <i className="wb webconnect-youtube"></i> Tutorials
                  </a>
                </li>
                <li>
                  <a
                    href="https://typeform229411.typeform.com/to/ZnBQ7y6u"
                    className="icon-link"
                    title="Feature Request?"
                    target="_blank"
                  >
                    <i className="wb webconnect-edit-solid"></i> Feature Request?
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div id="PAGES" className="sidebar">
          <PageTab projectId={projectId} version={version} isReadOnly={isReadOnly} />
        </div>
        <div id="COLLECTIONS" className="sidebar">
          <CollectionTab projectId={projectId} version={version} isReadOnly={isReadOnly} />
        </div>
        <div id="TEMPLATES" className="sidebar">
          <SnippetTemplateTab projectId={projectId} version={version} isReadOnly={isReadOnly} />
        </div>
        <div id="EVENTS" className="sidebar">
          <EventTab projectId={projectId} version={version} isReadOnly={isReadOnly} />
        </div>
        <div id="ASSETS" className="sidebar">
          <AssetTab projectId={projectId} version={version} isReadOnly={isReadOnly} />
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    home: state.home,
    tutorial: state.tutorial,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    tutorialActions: bindActionCreators({ ...tutorialActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
